/* tslint:disable */
/* eslint-disable */
export enum FeatureFlag {
  Authverificationemail = 'AUTHVERIFICATIONEMAIL',
  Authverificationtelegram = 'AUTHVERIFICATIONTELEGRAM',
  Maps = 'MAPS',
  Cardpresents = 'CARDPRESENTS'
}
